import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";
import { SwimmerFilter } from "../../../swimmers/components/SwimmerFilter/SwimmerFilter";
import { SwimmerTable } from "../../../swimmers/components/SwimmerTable/SwimmerTable";
import { useSwimmersTab } from "./useSwimmersTab";

export const SwimmersTab: React.FC = () => {
  const { swimmersResource, todayCount, handleEditSwimmer } = useSwimmersTab();

  return (
    <ResourceTab
      resource={{
        data: swimmersResource.data,
        isLoading: swimmersResource.isLoading,
        isError: swimmersResource.isError,
        page: swimmersResource.page,
        pageSize: swimmersResource.pageSize,
        handlePageChange: swimmersResource.handlePageChange,
        handlePageSizeChange: swimmersResource.handlePageSizeChange,
      }}
      filtersComponent={
        <SwimmerFilter
          swimmerName={swimmersResource.filters.swimmer_name}
          onSwimmerNameChange={(v) =>
            swimmersResource.handleFilterChange("swimmer_name", v)
          }
          onClearFilters={swimmersResource.resetFilters}
        />
      }
      tableComponent={
        <SwimmerTable
          swimmers={swimmersResource.data!}
          isLoading={swimmersResource.isLoading}
          isError={swimmersResource.isError}
          page={swimmersResource.page}
          pageSize={swimmersResource.pageSize}
          onPageChange={swimmersResource.handlePageChange}
          onPageSizeChange={swimmersResource.handlePageSizeChange}
          todayCount={todayCount}
          onEditSwimmer={handleEditSwimmer}
        />
      }
      emptyStateMessage="No hay bañistas para mostrar."
    />
  );
};
